// WHAT CAN BE CHANGED?
// Change the colour of the calendar-icon in the corresponding SVG-file

<template>
    <div id="YoutubeAPI" />
</template>

<script>
import $ from "jquery";

export default {
    name: "YoutubeAPI",
    created() {
        let self = this;
        $.get(
            "https://www.googleapis.com/youtube/v3/channels",
            {
                part: "contentDetails",
                forUsername: "rtvptv",
                key: "AIzaSyAi8rqjyOXZ3qlDHoDO8CTQTYtuam-PLNM",
            },
            function (data) {
                $.each(data.items, function (i, item) {
                    let uid = item.contentDetails.relatedPlaylists.uploads;
                    self.getVideos(uid);
                });
            }
        );
    },
    mounted() {
        let self = this;
        document
        .querySelector("#YoutubeAPI")
        .addEventListener("click", function (event) {
            if (event.target.className == "YoutubeAPI__video-container") {
            console.log("Video clicked")
            self.pauseRadioPlayer();
            $("iframe").remove();
            $("#missed__video-player").append(
                "<iframe src='//www.youtube.com/embed/" +
                event.target.id +
                "?autoplay=1&mute=0' width=100% height=100% allowfullscreen/>"
            );
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.getElementById("missed__video-player").style.paddingBottom =
                "56.25%";
            }
        });
    },
    methods: {
        getVideos(uid) {
            let self = this;
            $.get(
                "https://www.googleapis.com/youtube/v3/playlistItems",
                {
                    part: "snippet",
                    maxResults: 20,
                    playlistId: uid,
                    key: "AIzaSyAi8rqjyOXZ3qlDHoDO8CTQTYtuam-PLNM",
                },
                function (data) {
                    let output;
                    $.each(data.items, function (i, item) {
                        let videoTitle = item.snippet.title;
                        let videoPublished = self.getDisplayDate(item.snippet.publishedAt);
                        let videoId = item.snippet.resourceId.videoId;
                        output =
                        "<div class='YoutubeAPI__video-container' id=" +
                        videoId +
                        " ><div class='YoutubeAPI__video-container__video' style='background-image: url(https://img.youtube.com/vi/" +
                        videoId +
                        "/mqdefault.jpg'></div>" +
                        "<img src='img/icon-play-white.9a1de108.svg' class='YoutubeAPI__video-container__play-icon'>" +
                        "<div class='YoutubeAPI__video-container__text'><p>" +
                        videoTitle +
                        "</p>" +
                        "<img src='img/icons/icon-date.svg'/>" +
                        "<p class='YoutubeAPI__video-container__text__date'>" +
                        videoPublished +
                        "</p></div></div>";
                        $("#YoutubeAPI").append(output);
                    });
                }
            );
        },
        getDisplayDate(originalDate) {
            let displayDate = "";
             // Day
            displayDate += originalDate.slice(8, 10) + " ";
             // Month
            switch (originalDate.slice(5, 7)) {
                case "01":
                    displayDate += "januari ";
                    break;
                case "02":
                    displayDate += "februari ";
                    break;
                case "03":
                    displayDate += "maart ";
                    break;
                case "04":
                    displayDate += "april ";
                    break;
                case "05":
                    displayDate += "mei ";
                    break;
                case "06":
                    displayDate += "juni ";
                    break;
                case "07":
                    displayDate += "juli ";
                    break;
                case "08":
                    displayDate += "augustus ";
                    break;
                case "09":
                    displayDate += "september ";
                    break;
                case "10":
                    displayDate += "oktober ";
                    break;
                case "11":
                    displayDate += "november ";
                    break;
                case "12":
                    displayDate += "december ";
                    break;
            }
            // Year
            displayDate += originalDate.slice(0, 4);
            return displayDate;
        },
        pauseRadioPlayer() {
            let audio = $("audio")[0];
            if (!audio.paused) {
                audio.pause();
                $("#radioplayer__data__button-container button").removeClass("icon-pause");
                $("#radioplayer__data__button-container button").addClass("icon-play");
            }
        }
    }
};
</script>

<style lang="scss">
$youtube-api__text--colour: #F55000;
$youtube-api__text--font: "Lato";

#YoutubeAPI {
    max-width: 768px;

    .YoutubeAPI__video-container {
        display: grid;
        grid-template-columns: 110px 1fr;
        margin-bottom: 12px;
        font-family: $youtube-api__text--font;

        .YoutubeAPI__video-container__video {
            height: 75px;
            width: auto;
            background-position: center;
            background-size: cover;
            cursor: pointer;
            pointer-events: none;
        }

        .YoutubeAPI__video-container__play-icon {
            height: 20px;
            position: absolute;
            margin-top: 25px;
            margin-left: 48px;
            pointer-events: none;
        }

        .YoutubeAPI__video-container__text {
            padding-left: 12px;
            font-size: 14px;
            font-weight: bold;
            position: relative;
            pointer-events: none;

            img {
                display: block;
                position: absolute;
                bottom: 2px;
                height: 13px;
                width: auto;
            }

            .YoutubeAPI__video-container__text__date {
                position: absolute;
                margin-left: 16px;
                bottom: 0;
                color: $youtube-api__text--colour;
            }
        }
    }
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  #YoutubeAPI {
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  #YoutubeAPI {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  #YoutubeAPI {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #YoutubeAPI {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #YoutubeAPI {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
  }
}
</style>